import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { ROUTES } from "./defines/routes";

export function useResidentCardVerifyAnalytics() {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);

  useEffect(() => {
    if (pathname === ROUTES.residentCardVerify) {
      setMktgPageData(
        {
          resident_card_validation: "1",
        },
        "residentCardVerify"
      );
    }
  }, [pathname]);
}
